import React from 'react';

import { DetailUAbout, U } from '../../../../assets/img/svg/details';

const FinalSection: React.FC = () => {
    return (
        <section className='py-8 bg-main-blue md:bg-transparent'>
            <div className="max-w-[1300px] mx-auto relative">
                <DetailUAbout className='w-full h-full hidden md:block'/>
                <U className='w-24 h-24 block md:hidden absolute right-4 -top-8 rotate-12'/>

                <div className="md:absolute left-0 top-0 w-full h-full flex items-center">
                    <div className="max-w-screen-lg mx-auto px-4 w-full text-white flex flex-col md:flex-row gap-4 md:gap-10 xl:gap-20 justify-center xl:justify-start">
                        {/* <h2 className="font-semibold text-2xl md:text-4xl opacity-0">
                            Lorem <br/> Ipsum 
                        </h2> */}

                        <div className="xl:min-w-24"></div>

                        <div className="text-sm md:max-w-[450px] z-10">
                            A Uniexpo é um espaço de conexão entre estudantes em busca de propósito e instituições comprometidas com a formação de novos talentos. Um encontro essencial para escolhas mais conscientes e trajetórias promissoras. Faça parte desse movimento!
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FinalSection;